import { render } from "./modelsix.vue?vue&type=template&id=1052b54c"
import script from "./modelsix.vue?vue&type=script&lang=js"
export * from "./modelsix.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__